import { createSelector } from 'reselect';
import LegalConsentKeys from 'forms-utils-lib/legalConsent/constants/legalConsentKeys';

// @ts-expect-error FIXME: Could not find a declaration file for module
import { getLegalConsentOptions } from 'FormsUI/selectors/LegalConsent';
// @ts-expect-error FIXME: Could not find a declaration file for module
import getSubscriptionsForLegalConsent from 'FormsUI/selectors/legalConsent/getSubscriptionsForLegalConsent';
export const getUnselectedSubscriptionsForLegalConsent = createSelector(getLegalConsentOptions, getSubscriptionsForLegalConsent, (legalConsent, subscriptions) => {
  if (!legalConsent) {
    return [];
  }
  const consentCheckboxes = legalConsent[LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES];
  const currentIds = consentCheckboxes.map(({
    communicationTypeId
  }) => communicationTypeId);
  return subscriptions.filter(({
    id
  }) => currentIds.indexOf(id) === -1);
});
export default getUnselectedSubscriptionsForLegalConsent;